// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2pxxj","errorLogs":"styles_errorLogs__1rU_W"};